'use client';

import { useOpenAppUrl } from '@hooks/use-open-app-url';
import { Box, Overlay, Stack, Text } from '@ui-lib';

import { overlayStyleOverrides } from '../shared.css';
import { blinqAppLink, containerStyle } from './styles.css';

export const IndividualUserUnspportedBreakpointOverlay = (): JSX.Element => {
  const { appStore } = useOpenAppUrl({ includeOpaqueToken: false });

  return (
    <Overlay className={overlayStyleOverrides}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexGrow={1}
        paddingX="medium"
        className={containerStyle}
      >
        <Stack gap="large" align="center">
          <Box style={{ maxWidth: '580px' }}>
            <Stack align="center" gap="large">
              <Text align="center">
                The Blinq dashboard isn&apos;t currently optimised for mobile.
              </Text>
              <Text align="center">
                For the best mobile experience, download the Blinq app using the following link:
              </Text>
            </Stack>
          </Box>
          <Box component="a" href={appStore} className={blinqAppLink} borderRadius="large">
            <Text tone="neutralInverted" weight="demibold">
              Download the app
            </Text>
          </Box>
        </Stack>
      </Box>
    </Overlay>
  );
};
